const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
        }, wait);
    };
}

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
      var result = fn();
      if(result) {
        resolve(result);
      }
      else if (Number(new Date()) < endTime) {
        setTimeout(checkCondition, interval, resolve, reject);
      }
      else {
          reject(new Error('timed out for ' + fn + ': ' + arguments));
      }
  };

  return new Promise(checkCondition);
}

// Focus trapping for ADA
function trapFocusInDialog(dialog) {
  dialog.addEventListener('keydown', function(e) {
    let keyboardfocusableElements = dialog.querySelectorAll('a[href]:not(.hidden a[href]), button:not(.hidden button), input:not(.hidden input), textarea:not(.hidden textarea), select:not(.hidden select), details:not(.hidden details), [tabindex]:not([tabindex="-1"]):not(.hidden [tabindex]:not([tabindex="-1"]))');
    let firstFocusableElement = keyboardfocusableElements[0]; 
    let lastFocusableElement = keyboardfocusableElements[keyboardfocusableElements.length - 1];
    if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });      
}

window.addEventListener('load', () => {
  [...document.querySelectorAll('[role="dialog"]')].forEach(dialog => trapFocusInDialog(dialog));
});


function updateAriaHidden(swiper) {
  swiper.querySelectorAll('.swiper-slide').forEach(slide => {
    const isVisible = slide.classList.contains('swiper-slide-visible');
    slide.setAttribute('aria-hidden', String(!isVisible));
  });
}

function watchSlides(swiper) {
  updateAriaHidden(swiper);
  const slideObserver = new MutationObserver(mutations => {
    if (mutations.some(m =>
      m.type === 'attributes' &&
      m.attributeName === 'class' &&
      m.target.classList.contains('swiper-slide')
    )) {
      updateAriaHidden(swiper);
    }
  });
  const observeAllSlides = () => {
    swiper.querySelectorAll('.swiper-slide').forEach(slide => {
      slideObserver.observe(slide, { attributes: true });
    });
  };
  observeAllSlides();
  const container = swiper.querySelector('.swiper-container');
  if (container) {
    const containerObserver = new MutationObserver(() => {
      slideObserver.disconnect();
      observeAllSlides();
      updateAriaHidden(swiper);
    });
    containerObserver.observe(container, { childList: true, subtree: true });
  }
}

function initSwiperWatcher() {
  const selectors = ['swiper-carousel', 'swiper-image-gallery'];
  const init = (root = document) => {
    selectors.forEach(tag => {
      root.querySelectorAll(tag).forEach(swiper => {
        if (!swiper.hasAttribute('data-aria-watching')) {
          watchSlides(swiper);
          swiper.setAttribute('data-aria-watching', 'true');
        }
      });
    });
  };
  init();
  const pageObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) init(node);
      });
    });
  });
  pageObserver.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSwiperWatcher);
} else {
  initSwiperWatcher();
}

